var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ValidatorService_1;
import { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import { name as isEmailName, isEmail } from './validators/isEmail';
import { name as isNotEmptyName, isNotEmpty } from './validators/isNotEmpty';
import { name as isLoggedInName, isLoggedIn } from './validators/isLoggedIn';
import { name as isPasswordName, isPassword } from './validators/isPassword';
import { name as maximumLengthName, maximumLength } from './validators/maximumLength';
import { name as minimumLengthName, minimumLength } from './validators/minimumLength';
export const name = 'ValidatorService';
export var EvaluationTypes;
(function (EvaluationTypes) {
    EvaluationTypes["eager"] = "eager";
    EvaluationTypes["lazy"] = "lazy";
    EvaluationTypes["allRules"] = "allRules";
})(EvaluationTypes || (EvaluationTypes = {}));
let ValidatorService = ValidatorService_1 = class ValidatorService {
    constructor() {
        this.validators = new Map();
        this.init();
    }
    init() {
        this.validators.set(isEmailName, isEmail);
        this.validators.set(isNotEmptyName, isNotEmpty);
        this.validators.set(isLoggedInName, isLoggedIn);
        this.validators.set(isPasswordName, isPassword);
        this.validators.set(maximumLengthName, maximumLength);
        this.validators.set(minimumLengthName, minimumLength);
    }
    static create() {
        return new ValidatorService_1();
    }
    /**
     * Perform validations of each validation rule in the rule set
     *
     * @param rules a valiationRuleset containing the validation type, params, message
     * @returns {Array} an array of errors of type ValidationError
     */
    async validate(rules) {
        const validationRules = rules.getValidationRules();
        // declare an empty array that will eventually take in errors that get returned by validator.ts
        const errors = [];
        for (const rule of validationRules) {
            const { type, params, message } = rule;
            // Perform a lookup in our validatorTypeMap and retrieve the value associated with the provided type
            const validatorFunction = this.validators.get(type);
            if (typeof validatorFunction === 'undefined') {
                Logger.error(`Validation type ${type} does not exist.`);
            }
            let result;
            // Need to fetch the value every time so validation always validates against latest value
            const elementValue = document.getElementById(rules.elementId).value;
            if (params) {
                result = await validatorFunction(elementValue, ...params); // eslint-disable-line no-await-in-loop
            }
            else {
                result = await validatorFunction(elementValue); // eslint-disable-line no-await-in-loop
            }
            // If a ValidationError gets returned, add it to errors array.
            if (result === false) {
                const error = {
                    type,
                    message: message || validatorFunction.defaultMessage,
                };
                errors.push(error);
            }
        }
        // If errors exists, return array, else return true
        return errors.length ? errors : true;
    }
    addValidator(validationName, validationFunction) {
        this.validators.set(validationName, validationFunction);
    }
};
ValidatorService = ValidatorService_1 = __decorate([
    injectable({
        key: name,
        scope: InjectorScope.Singleton,
    })
], ValidatorService);
export default ValidatorService;
